import { Model } from 'api/Exec/types';
import { formatDateTime } from 'app/helpers/dateTime';

import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Typography } from 'antd';
import { ColumnsType, ColumnType } from 'antd/es/table';
import React from 'react';

const useColumns = (onDetailsClick: (model: Model) => void, addingNamedModel?: boolean) => {
  const columns: ColumnsType<Model> = [
    {
      title: 'Model API',
      dataIndex: 'modelApiName',
      key: 'modelApiName',
    },
    {
      title: 'Image tag',
      dataIndex: 'imageTag',
      key: 'imageTag',
    },
    {
      title: 'Push date',
      key: 'imagePushedAt',
      render: (_, { imagePushedAt }) => <Typography.Text style={{ whiteSpace: 'nowrap' }}>{formatDateTime(imagePushedAt)}</Typography.Text>,
    },
    ...(!addingNamedModel ? [ {
      title: 'Model names',
      dataIndex: 'assignedName',
      key: 'assignedName',
    } as ColumnType<Model> ] : []),
    {
      title: 'Sandbox',
      key: 'sandbox',
      align: 'center',
      render: (_, { isSandbox }) => {
        return isSandbox ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    {
      title: 'CV',
      key: 'clinicalValidated',
      align: 'center',
      render: (_, { clinicalValidated }) => {
        return clinicalValidated ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    ...(!addingNamedModel ? [ {
      title: 'Git commit',
      key: 'gitCommit',
      render: (_, { gitCommit }) => {
        return <Typography.Link href={gitCommit} target="_blank">{gitCommit.split('/').pop()}</Typography.Link>;
      },
    } as ColumnType<Model> ] : [ ]),
    {
      title: 'Actions',
      key: 'actions',
      render: (_, model) => {
        return (
          <Typography.Link ellipsis onClick={() => onDetailsClick(model)}>
            Details
          </Typography.Link>
        );
      },
    },
  ];

  return { columns };
};

export default useColumns;
